<template>
  <div class="bg-green-200">
    <TopNav :record="record" @save="onSavePage" @exit="onExit" />
    <SideNav :properties="record" :sections="sections" :footer="footer" :selected="selectedSection"
      @select="onSelectSection" @select-sub-section="onSelectSubSection" @add-section="onAddSection"
      @add-sub-section="onAddSubSection" @delete-section="onDeleteSection" @move-section="onMoveSection"
      @move-sub-section="onMoveSubSection" @update-section="onUpdateSection" />
    <RightSideNav :selected-section="selectedSection" :record="record" @delete-section="onDeleteSection"
      @update-section="onUpdateSection" @openmodal="onOpenModal" @queryBuilder="onOpenQueryBuilderModal" />
    <EditorBody mode="smartphone" :record="record" :selected="selectedSection" :sections="sections"
      @item-click="onSelectSectionBody" />
    <SelectDataSourceModal />

    <SelectQueryBuilderModal @close="onQueryBuilderModalClose" @confirm="onQueryBuilderModalConfirm" :values="values"
      :attributes="attributes" />

  </div>
</template>

<script>
import TopNav from '@/layout/Editor/TopNavEditor.vue'
import SideNav from '@/layout/Editor/SideNavEditor.vue'
import RightSideNav from '@/layout/Editor/SideRightNavEditor.vue'
import EditorBody from '@/layout/Editor/EditorBody.vue'

import { Modal } from 'flowbite';
import SelectDataSourceModal from '@/layout/Editor/Modals/SelectDataSourceModal.vue'
import SelectQueryBuilderModal from '@/layout/Editor/Modals/SelectQueryBuilderModal.vue'

import service from "@/services/FullService.vue"
import { mapGetters } from "vuex";
import { unflatten, flatten } from 'flat'


export default {
  name: 'EditorLayout',
  components: {
    SideNav, TopNav, RightSideNav, EditorBody, SelectDataSourceModal, SelectQueryBuilderModal
  },
  data() {
    return ({
      queryBuilderModal: null,
      select_datasource_modal: null,



      attributes: [
        {
          "id": "first_name",
          "name": "Prénom",
          "type": "string"
        },
        {
          "id": "last_name",
          "name": "Nom",
          "type": "string"
        },
        {
          "id": "plan",
          "name": "Plan Type",
          "type": "list",
          "values": [
            {
              "id": "free", "name": "Free"
            },
            {
              "id": "premium", "name": "Premium"
            }
          ]
        }
      ],
      values: {
        rules: [
          {

            id: 1,
            name: "check_16",
            type: "list",
            attribute: "check_16",
            action: "does-not-equal",
            value: "NO",
            values: [
              {
                "id": "free", "name": "Free"
              },
              {
                "id": "premium", "name": "Premium"
              }
            ]
          }
        ],
      },




      record: {},
      footer: {
        left: [],
        right: [],
        center: []
      },
      data: { sections: [] },
      sections: [],

      selectedSection: null
    })
  },
  computed: {
    ...mapGetters({ user: "StateUser" }),
    isLoggedIn: function () {
      return this.$store.getters.isAuthenticated;
    },
  },
  watch: {
    '$route.params.id': async function () {
      await this.loadForm()
    }
  },
  async mounted() {
    await this.loadForm()

    const modalEl = document.getElementById('select-query-builder-modal');

    this.queryBuilderModal = new Modal(modalEl, {
      placement: 'center'
    });


  },
  methods:
  {

    onOpenQueryBuilderModal(/*event*/) {
      this.queryBuilderModal.show();
    },



    onQueryBuilderModalClose(/*event*/) {
      this.queryBuilderModal.hide();
    },


    onQueryBuilderModalConfirm(/*event*/) {
      this.queryBuilderModal.hide();
    },




    onOpenModal(/*event*/) {

    },



    loadForm: async function () {
      let id = this.$route.params.id;

      if (this.user == undefined) {
        //this.$router.push("/login");
        window.location = "/login?redirect=/admin/editor/forms/" + id;
        return;
      }

      let r = await service.getDataId("workflow-forms", id, this.user.token, {})
      this.record = r;

      this.sections = this.record?.properties?.pages[0]?.components
    },
    onMoveSection: function (event) {

      if (event.zone == "body")
        this.record?.properties?.pages[0]?.components?.splice(event.newIndex, 0, this.record?.properties?.pages[0]?.components?.splice(event.oldIndex, 1)[0]);

    },
    onMoveSubSection: function (event) {
 

      if (event.zone == "body") {
        let section = this.record?.properties?.pages[0]?.components?.find(function (v) { return v.id == event.parent })
        if (section != undefined)

          section.components?.splice(event.newIndex, 0, section?.components?.splice(event.oldIndex, 1)[0]);

      }

    },
    onDeleteSection: function (event) {


      if (event == undefined) { return; }
      if (this.record == undefined) { return; }
      if (this.record?.properties?.pages == undefined) { return; }




      {
        let index = this.record?.properties?.pages[0]?.components?.findIndex(function (v) { return v.id == event.id })


        if (index != -1) {

          this.selectedSection = null
          const arrayOfLetters = this.record?.properties?.pages[0]?.components

          const halfBeforeTheUnwantedElement = arrayOfLetters.slice(0, index)

          const halfAfterTheUnwantedElement = arrayOfLetters.slice(index + 1);
          const copyWithoutThirdElement = halfBeforeTheUnwantedElement.concat(halfAfterTheUnwantedElement);
          this.record.properties.pages[0].components = copyWithoutThirdElement
          this.record.updated_at = new Date()

          this.sections = this.record?.properties?.pages[0]?.components
          return;
        }

      }

      {
        let index = this.record?.properties?.pages[0].submit.areas?.left?.findIndex(function (v) { return v.id == event.id })
        if (index != -1) {
          this.selectedSection = null
          const arrayOfLetters = this.record?.properties?.pages[0].submit.areas?.left

          const halfBeforeTheUnwantedElement = arrayOfLetters.slice(0, index)

          const halfAfterTheUnwantedElement = arrayOfLetters.slice(index + 1);
          const copyWithoutThirdElement = halfBeforeTheUnwantedElement.concat(halfAfterTheUnwantedElement);
          this.record.properties.pages[0].submit.areas.left = copyWithoutThirdElement
        }
     
      }

      {
        let index = this.record?.properties?.pages[0].submit.areas?.center?.findIndex(function (v) { return v.id == event.id })
        if (index != -1) {
          this.selectedSection = null
          const arrayOfLetters = this.record?.properties?.pages[0].submit.areas?.center

          const halfBeforeTheUnwantedElement = arrayOfLetters.slice(0, index)

          const halfAfterTheUnwantedElement = arrayOfLetters.slice(index + 1);
          const copyWithoutThirdElement = halfBeforeTheUnwantedElement.concat(halfAfterTheUnwantedElement);
          this.record.properties.pages[0].submit.areas.center = copyWithoutThirdElement
        }
 
      }

      {
        let index = this.record?.properties?.pages[0].submit.areas?.right?.findIndex(function (v) { return v.id == event.id })
        if (index != -1) {
          this.selectedSection = null
          const arrayOfLetters = this.record?.properties?.pages[0].submit.areas?.right

          const halfBeforeTheUnwantedElement = arrayOfLetters.slice(0, index)

          const halfAfterTheUnwantedElement = arrayOfLetters.slice(index + 1);
          const copyWithoutThirdElement = halfBeforeTheUnwantedElement.concat(halfAfterTheUnwantedElement);
          this.record.properties.pages[0].submit.areas.right = copyWithoutThirdElement
          //     console.log("this.record?.properties?.pages[0].submit.areas?.right", index)

        }
      }

      //    console.log(JSON.stringify(this.record?.footer))
      return true
    },
    onUpdateSection: function (event) {


      {
        let index = this.record?.properties?.pages[0]?.components?.findIndex(function (v) { return v.id == event.id })
        //  console.log("Body ", index)
        if (index != -1) {

          if (event.att == "_events") {
            this.record.properties.pages[0].components[index]._events = event.value

            return;
          }
          if (event.att == "_controls") {
            this.record.properties.pages[0].components[index]._controls = event.value

            return;
          }
          let f = flatten(this.record.properties.pages[0].components[index])


          f[event.att] = event.value
          let u = unflatten(f)

          this.record.properties.pages[0].components[index] = u
          return;
        }
      }
      {
        let listComponents = this.record?.properties?.pages[0]?.components?.filter(function (v) { return v.type == 'list' })


        if (listComponents.length > 0) {


          for (let y = 0; y < listComponents.length; y++) {


            let index = listComponents[y].components?.findIndex(function (v) { return v.id == event.id })

            if (index != -1) {

              let f = flatten(listComponents[y].components[index])
              f[event.att] = event.value
              let u = unflatten(f)
              listComponents[y].components[index] = u
              return;
            }
          }
        }
      }
      {
        let index = this.record?.properties?.pages[0].submit.areas.left.findIndex(function (v) { return v.id == event.id })
        if (index != -1) {
          this.record.properties.pages[0].submit.areas.left[index][event.att] = event.value
        }
      }

      {
        let index = this.record?.properties?.pages[0].submit.areas.center.findIndex(function (v) { return v.id == event.id })
        //    console.log("center ", index)
        if (index != -1) {
          this.record.properties.pages[0].submit.areas.center[index][event.att] = event.value
        }
      }


      {
        let index = this.record?.properties?.pages[0].submit.areas.right.findIndex(function (v) { return v.id == event.id })
        //      console.log("Right ", index)
        if (index != -1) {
          this.record.properties.pages[0].submit.areas.right[index][event.att] = event.value
        }
      }



    },
    onAddSection: function (event) {



      if (event.zone == "body") {
        //       console.log("Zone  BODY")
        if (event.after == undefined) {
          delete event.section.images

          this.record?.properties?.pages[0]?.components.push(event.section)

        }
        else {
          let index = this.record?.properties?.pages[0]?.components?.findIndex(function (v) {


           
            return v.id == event.after
          })
        
          if (index != -1) {

            this.record?.properties?.pages[0]?.components?.splice(index + 1, 0, event.section);
          }
          else {
            console.log("ERROR ERROR ERROR ERROR ",)
            
          }


        }
      }
      if (event.zone == "footer") {



        if (event.area == "left") {
 
          if (event.after == undefined) {
            delete event.section.images
            this.record?.properties?.pages[0].submit.areas.left.push(event.section)
          }
          else {
            let index = this.record?.properties?.pages[0].submit.areas.left.findIndex(function (v) { return v.id == event.after })
    
            this.record?.properties?.pages[0].submit.areas.left.splice(index + 1, 0, event.section);
          }
        }
        if (event.area == "center") {

     


          if (event.after == undefined) {
            delete event.section.images
            this.record?.properties?.pages[0].submit.areas.center.push(event.section)
          }
          else {
            let index = this.record?.properties?.pages[0].submit.areas.center.findIndex(function (v) { return v.id == event.after })
        
            this.record?.properties?.pages[0].submit.areas.center.splice(index + 1, 0, event.section);
          }
        }
        if (event.area == "right") {
          

          if (event.after == undefined) {
            delete event.section.images
            this.record?.properties?.pages[0].submit.areas.right.push(event.section)
          }
          else {
            let index = this.record?.properties?.pages[0].submit.areas.right.findIndex(function (v) { return v.id == event.after })
             
            this.record?.properties?.pages[0].submit.areas.right.splice(index + 1, 0, event.section);
          }
        }

      }
      this.selectedSection = event.section
      // 

    },
    onAddSubSection: function (event) {
 


      if (event.zone == "body") {

        let parent = this.record?.properties?.pages[0]?.components?.find(function (v) { return v.id == event.parent })

        if (event.after == undefined) {
          delete event.section.images
          parent?.components?.push(event.section)

        }
        else {
          let index = this.record?.properties?.pages[0]?.components?.findIndex(function (v) { return v.id == event.after })
 
          if (index != 1) {

            this.record?.properties?.pages[0]?.components?.splice(index + 1, 0, event.section);
          }
          else {
            console.log("ERROR ERROR ERROR ERROR ",)
          }


        }
      }

    },
    onSelectSection: function (section) {

      {


        let source = this.record?.properties?.pages[0].components
        let index = source?.findIndex(function (v) { return v.id == section.id })

        //let index = this.record?.sections?.findIndex(function (v) { return v.id == section.id })
     
        if (index != -1)
          this.selectedSection = source[index]
      }
      {
        let index = this.record?.properties?.pages[0].submit.areas.left.findIndex(function (v) { return v.id == section.id })
     
        if (index != -1)
          this.selectedSection = this.record?.properties?.pages[0].submit.areas.left[index]
      }

      {
        let index = this.record?.properties?.pages[0].submit.areas.center.findIndex(function (v) { return v.id == section.id })
 
        if (index != -1)
          this.selectedSection = this.record?.properties?.pages[0]?.submit.areas.center[index]
      }

      {
        let index = this.record?.properties?.pages[0]?.submit.areas.right.findIndex(function (v) { return v.id == section.id })
        
        if (index != -1)
          this.selectedSection = this.record?.properties?.pages[0]?.submit.areas.right[index]
      }


    },
    onSelectSubSection: function (section) {
 
      {


        let source = this.record?.properties?.pages[0].components
        let item = source?.find(function (v) { return v.id == section.parent })
      
        let index = item?.components?.findIndex(function (v) { return v.id == section.id })
 
        if (index != -1)
          this.selectedSection = item.components[index]
 
      }
    },




    onSelectSectionBody: function (section) {

      if (section.zone == "body")
        this.selectedSection = section

    },


    onExit: function () {
      this.$router.go(-1)
    },
    onSavePage: async function () {

      let id = this.$route.params.id;
      await service.updateRecord("workflow-forms", id, this.user.token, this.record)
     
    },
    onSectionClick: function (section) {

 
      if (section.zone == "body")
        this.selectedSection = section


      if (section.zone == "footer")
        this.selectedSection = section
    }
  }
}
</script>